var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[_c('Restricted',{attrs:{"permission":"user.manage"}},[_c('TabBar',{attrs:{"tabs":_vm.tabs,"current-tab":_vm.currentTab},on:{"update:currentTab":function($event){_vm.currentTab=$event},"update:current-tab":function($event){_vm.currentTab=$event}}})],1),_c('keep-alive',[_c(_vm.tab,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }